import React from 'react';
import { NoDataMessage } from './styles';

export default function MessageComponent(props) {
  const { metrics = [], selectedMetrics = [], demo } = props;
  const hasMetrics = metrics.length > 0;
  const hasSelected = selectedMetrics.length > 0;

  if (!hasMetrics && !demo) {
    return <NoDataMessage>Metrics are not found.</NoDataMessage>;
  }

  if ((demo || hasMetrics) && !hasSelected) {
    return <NoDataMessage>Select at least one metric in Metrics field.</NoDataMessage>;
  }

  return null;
}
